function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 5l.646 10.976c.124 2.12.187 3.18.64 3.985a4 4 0 001.733 1.635C7.849 22 8.91 22 11.035 22h1.93c2.124 0 3.186 0 4.016-.404a4 4 0 001.734-1.635c.452-.805.515-1.865.64-3.985L20 5M4 5H2m2 0h16m0 0h2m-6 0l-.453-1.359c-.197-.59-.295-.885-.478-1.103a1.5 1.5 0 00-.601-.434C14.203 2 13.892 2 13.27 2h-2.54c-.622 0-.933 0-1.198.104a1.5 1.5 0 00-.602.434c-.182.218-.28.513-.477 1.103L8 5m2 5v7m4-7v4"
});

var SvgTrashNew = function SvgTrashNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default SvgTrashNew;